import { ROUTE_PATHS } from '@config/routes';

let appNavigate = null;

export const bindAppNavigate = (navigate) => {
  appNavigate = navigate;
};

export const unbindAppNavigate = () => {
  appNavigate = null;
};

/** Client-side login redirect (no full page reload). */
export const navigateToLogin = () => {
  if (window.location.pathname === ROUTE_PATHS.LOGIN) return;

  if (appNavigate) {
    appNavigate(ROUTE_PATHS.LOGIN, { replace: true });
    return;
  }
};

export default {
  bindAppNavigate,
  unbindAppNavigate,
  navigateToLogin,
};
